// Fonte unica: le o financial{} ja salvo pelo motor (ver quote-financial-engine.js
// e entradaMotorFinanceiro em montarESalvarPedidoObj). Pedidos antigos sem
// financial{} ainda salvo caem no fallback, calculado com o mesmo motor.
function calcMargemPedidoData(p){
  if(!p)return null;
  const val=parseFloat(p.valor)||0;
  let custo,lucro,pct;
  if(p.financial){
    custo=p.financial.totalCost;lucro=p.financial.profit;pct=Math.round(p.financial.margin);
  }else if(typeof QuoteFinancialEngine!=='undefined'){
    const indicador=p.indicadorId?parceirosComerciais().find(f=>f.id===p.indicadorId):null;
    const r=QuoteFinancialEngine.compute(entradaMotorFinanceiro(p.custos,val,indicador,CACHE.config,p.custos?.comissaoOverride));
    custo=r.totalCost;lucro=r.profit;pct=Math.round(r.margin);
  }else return null;
  if(!val||!custo) return null;
  return {custo, lucro, pct};
}
function calcMargemConsolidadaPedidos(pedidos=[]){
  const base=(pedidos||[]).map(p=>{
    const receita=geoNum(p.valor);
    const margem=calcMargemPedidoData(p);
    const custoTotal=geoNum(p.custoTotal)||(margem?margem.custo:0);
    return {receita,custoTotal};
  }).filter(x=>x.receita>0&&x.custoTotal>0&&Number.isFinite(x.receita)&&Number.isFinite(x.custoTotal));
  const receitaTotal=base.reduce((s,x)=>s+x.receita,0);
  const custoTotal=base.reduce((s,x)=>s+x.custoTotal,0);
  const lucro=receitaTotal-custoTotal;
  const pctRaw=receitaTotal?(lucro/receitaTotal)*100:0;
  const pct=Math.round(Math.max(-999,Math.min(100,pctRaw))*10)/10;
  return {receitaTotal,custoTotal,lucro,pct,count:base.length,temDados:base.length>0};
}
function fmtPctKpi(v){
  const n=Number(v);
  if(!Number.isFinite(n))return'—';
  return n.toLocaleString('pt-BR',{minimumFractionDigits:1,maximumFractionDigits:1})+'%';
}
function margemBadge(p){
  const m=calcMargemPedidoData(p);
  if(!m||!m.pct) return '';
  const cor=m.pct<0?'#f06595':m.pct<20?'#ffa94d':'#00d4aa';
  const icon=m.pct<0?'📉':m.pct<20?'⚠️':'✅';
  return `<span title="Margem ${m.pct}%" style="font-size:10px;background:${cor}22;color:${cor};padding:1px 6px;border-radius:10px;font-weight:700">${icon} ${m.pct}%</span>`;
}

